"use strict";
import {config, cities, pdfFile} from '../_config'
import axios from 'axios';

export const routesService = {
  getAll,
  search,
  getTransport,
  getAccessPath,
  getCities,
  checkPdf,
  getPdf
}

async function getAll() {
  const res = axios.get(`${config.apiUrl}/todos`)
    .catch(err => console.error(`Error: ${err.message}`))

  const rawData = await res

  const result = {
    routes: [],
    nodes: []
  };
  if (rawData.status == '200') {
    const data = await rawData.data
    data.routes.forEach((e) => {
      result.routes.push(JSON.parse(e));
    })
    data.nodes.forEach((e) => {
      result.nodes.push(JSON.parse(e));
    })
    return result
  }
}

async function search(start, end) {

  const response = axios.get(`${config.apiUrl}/buscar/${start}/${end}`)

  const content = await response
  return content
}

async function getTransport() {
  const response = axios.get(`${config.apiUrl}/transport`)
  const rawData = await response

  const result = {
    busStops: [],
    busLines: [],
    trainStations: []
  }

  if (rawData.status == '200') {
    const data = await rawData.data
    data.stops.forEach(e => {
      result.busStops.push(JSON.parse(e))
    })
    data.lines.forEach(e => {
      result.busLines.push(JSON.parse(e))
    })

    data.stations.forEach(e => {
      result.trainStations.push(JSON.parse(e))
    })
  }
  return result
}

async function getAccessPath() {
  const res = axios.get(`${config.apiUrl}/accesos`)
    .catch(err => console.error(`Error: ${err.message}`))

  const rawData = await res

  const result = {
    routes: [],
    nodes: []
  };
  if (rawData.status == '200') {
    const data = await rawData.data
    data.routes.forEach((e) => {
      result.routes.push(JSON.parse(e));
    })
    data.nodes.forEach((e) => {
      result.nodes.push(JSON.parse(e));
    })
    return result
  }
}

async function getCities() {
  const response = axios.get(`${cities.url}`)
  const rawData = await response
  let data = {}
  if (rawData.status == '200') {
    data = await rawData.data
  }
  return data
}

async function checkPdf(sid, eid, start, end) {
  const response = axios.get(`${config.apiUrl}/checkpdf/${sid}/${eid}/${start}/${end}`)

  const content = await response
  return content
}

async function getPdf(fd) {
  const response = axios.post(`${config.apiUrl}/pdf`, fd)

  const content = await response
  return content
}



// WEBPACK FOOTER //
// ./src/_services/routes.service.js